import { emptyArray } from 'ui-components/default-props/empty';

import type { FreightProvider, FreightSettingsState } from './freight-settings.types';

export const selectProviders = (state: FreightSettingsState): FreightProvider[] => state.providers ?? emptyArray;
export const selectIsLoadingProviders = (state: FreightSettingsState): boolean => state.isLoadingProviders ?? false;
export const selectIsDisconnecting = (state: FreightSettingsState): boolean => state.isDisconnecting ?? false;
export const selectHasError = (state: FreightSettingsState): boolean => state.hasError ?? false;
export const selectErrorMessage = (state: FreightSettingsState): string => state.errorMessage ?? '';
